export default function AmbuSeva_Patient_Tnc() {
  return (
    <>
      <meta charSet="utf-8" />
      <p>AmbuSeva Patient App Terms &amp; Conditions</p>
      <p>
        Matri Mission 'O' Mandir Seva Trust - AmbuSeva Patient Application Terms
        &amp; Conditions
      </p>
      <p>Last Updated: 22nd Jan 2026.</p>
      <br />
      <h3>LEGAL NOTICE &amp; IMPORTANT DISCLAIMER</h3>
      <p>
        These Terms &amp; Conditions ("Terms") constitute a legally binding
        agreement between you ("User", "Patient", "You") and Matri Mission 'O'
        Mandir Seva Trust AmbuSeva Patient App ("Platform", "we", "us", "our"). By
        downloading, installing, accessing or using the patient mobile application
        (the "App") or any related services, you acknowledge that you have read,
        understood and agree to be bound by these Terms. If you do not agree to
        these Terms, you must immediately stop using the App.
      </p>
      <br />
      <h3>1. DEFINITIONS</h3>
      <p>
        1.1 "Ambulance Provider" or "Partner" means third-party ambulance
        owners/operators who independently provide ambulance services and use the
        Partner Application.
      </p>
      <p>
        1.2 "Driver" means the individual operating an ambulance and any in-vehicle
        medical personnel assigned by the Ambulance Provider.
      </p>
      <p>
        1.3 "Service" means the technology-enabled platform provided by the App to
        enable users to request ambulance services from Ambulance Providers.
      </p>
      <p>
        1.4 "Emergency" means any medical condition or circumstance requiring urgent
        ambulance transport or immediate medical attention.
      </p>
      <br />
      <h3>2. NATURE OF SERVICE</h3>
      <p>
        2.1 The Platform operates solely as a technology intermediary that
        facilitates connections between Users and Drivers provided by Ambulance
        Providers. Unless expressly stated otherwise in writing, the Platform
        neither owns, operates, controls nor manages any ambulances, drivers, health
        professionals, or medical personnel.
      </p>
      <p>
        2.2 The App does not provide medical advice, medical diagnosis, or direct
        medical services. Any information accessible within the App is for
        informational purposes only and is not a substitute for professional medical
        advice.
      </p>
      <p>
        2.3 Ambulance services, in whole or in part, are provided by independent
        third-party Ambulance Providers. First Aid Treatment decisions and medical
        outcomes are the sole responsibility of the Ambulance Provider and the
        attending medical personnel.
      </p>
      <br />
      <h3>3. ACCESS &amp; USER ELIGIBILITY</h3>
      <p>
        3.1 Eligibility: You must be at least eighteen (18) years of age and legally
        competent to enter into contracts. If you are under 18, a parent or legal
        guardian must use the App on your behalf.
      </p>
      <p>
        3.2 Accounts: Certain functionalities may require user registration. You
        must provide accurate and complete information and keep your account
        credentials secure.
      </p>
      <p>
        3.3 Consent to Communicate: By using the App, you consent to receive calls,
        messages, and notifications (including automated communications) from
        Ambulance Providers, the Platform, and third-party service providers for the
        purposes of providing the Service.
      </p>
      <br />
      <h3>4. SERVICE LIMITATIONS &amp; NO GUARANTEE OF AVAILABILITY</h3>
      <p>
        4.1 Availability: The Platform makes commercially reasonable efforts to
        present available ambulances in the vicinity; however, the Platform does not
        guarantee the availability of ambulances at any given time and at any given
        place, acceptance of a ride request, response time, arrival time, ambulance
        type, or medical staffing level.
      </p>
      <p>
        4.2 Non-Availability: In situations where an ambulance is not available via
        the App, we have no obligation to provide alternative transportation. Users
        acknowledge and accept that the Platform cannot and does not guarantee
        timely access to an ambulance in all circumstances.
      </p>
      <p>
        4.3 No Warranty: THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE." THE
        PLATFORM DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES
        OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, RELIABILITY,
        TIMELINESS, AND NON-INFRINGEMENT, TO THE MAXIMUM EXTENT PERMITTED BY LAW.
      </p>
      <br />
      <h3>5. EMERGENCY DISCLAIMER</h3>
      <p>
        5.1 Government Emergency Numbers: The App is not a substitute for
        government-run emergency services (e.g., 108, 112 or other local emergency
        numbers). In life-threatening situations or when urgent professional
        emergency response is required, Users must immediately contact local
        emergency services.
      </p>
      <p>
        5.2 User Responsibility: The User is responsible for making an independent
        judgment about the urgency and necessity of contacting government emergency
        services, in addition to any use of the App.
      </p>
      <br />
      <h3>6. LIMITATION OF LIABILITY</h3>
      <h3>
        6.1 TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW, THE PLATFORM, ITS
        AFFILIATES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS AND LICENSORS
        (COLLECTIVELY, "PLATFORM PARTIES") SHALL NOT BE LIABLE FOR: (A) ANY LOSS,
        DAMAGE, INJURY, ILLNESS, DETERIORATION OR DEATH ARISING FROM OR RELATED TO
        THE USE OR NON-USE OF THE APP; (B) THE ACTS OR OMISSIONS OF AMBULANCE
        PROVIDERS, DRIVERS OR MEDICAL PERSONNEL; (C) DELAYS, NON-AVAILABILITY, OR
        FAILURE OF AMBULANCE SERVICES; (D) MISROUTES, TRAFFIC DELAYS, OR ANY
        THIRD-PARTY ACTIONS; OR (E) INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR
        PUNITIVE DAMAGES.
      </h3>
      <h3>
        6.2 THE USER EXPRESSLY AGREES THAT THE ENTIRE RISK AS TO SATISFACTORY
        PERFORMANCE, ACCURACY, TIMELINESS, AND OUTCOME LIES WITH THE USER AND/OR THE
        THIRD-PARTY AMBULANCE PROVIDER, AND NOT WITH THE PLATFORM.
      </h3>
      <h3>
        6.3 NOTWITHSTANDING THE FOREGOING, NOTHING IN THESE TERMS SHALL EXCLUDE OR
        LIMIT LIABILITY THAT CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW,
        INCLUDING LIABILITY FOR FRAUD OR GROSS NEGLIGENCE.
      </h3>
      <h3>7. INDEMNIFICATION</h3>
      <p>
        7.1 You agree to indemnify, defend and hold harmless the Platform Parties
        from and against any and all claims, liabilities, damages, losses, costs and
        expenses (including reasonable legal fees) arising out of: (a) your breach
        of these Terms; (b) your negligence, wilful misconduct or fraud; (c)
        inaccurate information provided by you; or (d) any claim by a third party
        arising out of your use of the App.
      </p>
      <br />
      <h3>8. BOOKINGS, CANCELLATIONS, PAYMENTS &amp; REFUNDS</h3>
      <p>
        8.1 Booking Process: The App will present an estimate of charges (if any)
        prior to confirmation. Estimated charges are indicative; final charges are
        subject to final ride data and any driver side adjustments, like additional
        charges for use of oxygen cylinders.
      </p>
      <p>
        8.2 Payments: Payments may be processed through third-party payment gateways
        and are subject to their terms. The Platform is not the payment processor
        and shall not be liable for errors, failures, or delays in payment
        processing by payment processors.
      </p>
      <p>
        8.3 Cancellations: Cancellation policies may be set by Ambulance Providers
        and/or the Platform. Cancellation fees may apply in accordance with the
        cancellation policy displayed at the time of booking.
      </p>
      <p>
        8.4 Refunds: Refund decisions are made in good faith and are subject to
        Platform investigation and Ambulance Provider cooperation. Refunds, where
        applicable, will be processed back to the original mode of payment.
      </p>
      <br />
      <h3>9. USER OBLIGATIONS &amp; ACKNOWLEDGEMENTS</h3>
      <p>
        9.1 Accurate Information: You must provide complete and accurate
        information, including current, source and destination locations and contact
        details for emergency contacts.
      </p>
      <p>
        9.2 Cooperation: You agree to cooperate and behave respectfully with
        Drivers, Ambulance Providers, Emergency Staff and medical personnel and
        comply with their reasonable instructions during patient transfer.
      </p>
      <p>
        9.3 Prohibited Conduct: You shall not use the App for illegal purposes, to
        mislead Ambulance Providers, or to interfere with operations. Any misuse may
        result in account termination and liability for damages.
      </p>
      <p>
        9.4 Consent to Tracking: You consent to real-time gps location tracking for
        the purpose of delivering the Service and safety monitoring. Tracking may be
        used for billing, investigations, and regulatory compliance.
      </p>
      <br />
      <h3>10. MEDICAL TREATMENT</h3>
      <p>
        10.1 Medical Authority: Ambulance Providers and attending medical personnel
        retain authority over on-scene medical decisions and treatment based on
        their professional judgment.
      </p>
      <p>
        10.2 No Medical Advice by Platform: The Platform is not a medical provider
        and does not give medical advice. Any health-related content in the App is
        informational only and should not be relied upon for healthcare decisions.
      </p>
      <br />
      <h3>11. PRIVACY &amp; DATA PROTECTION</h3>
      <p>
        11.1 The Platform's Privacy Policy governs the collection, use, retention,
        and sharing of personal data. By using the App, you consent to the
        collection and use of information in accordance with the Privacy Policy.
      </p>
      <p>
        11.2 Sensitive Data: Health and medical information is treated as sensitive
        personal data. The Platform uses such data only for the purpose of providing
        ambulance and emergency-related services, and in accordance with applicable
        law.
      </p>
      <br />
      <h3>12. FORCE MAJEURE &amp; PANDEMIC CLAUSE</h3>
      <p>
        12.1 Definition: For the purposes of these Terms, "Force Majeure Event"
        includes natural disasters, floods, earthquakes, storms, fires, epidemics,
        pandemics, public health emergencies, government actions, civil unrest,
        strikes, labor disputes, acts of war, acts of God, or other events beyond
        the reasonable control of the Platform or Ambulance Providers.
      </p>
      <p>
        12.2 Suspension of Service: The Platform shall not be liable for any failure
        or delay in performance resulting from a Force Majeure Event. The Platform
        may suspend or modify the Service during such events without liability.
      </p>
      <p>
        12.3 Pandemic-Specific Measures: During a public health emergency or
        pandemic, Ambulance Providers, drivers, and medical staff may be constrained
        by public health directives, personal protective equipment shortages,
        quarantines, travel restrictions, or reduced staffing. The Platform cannot
        guarantee availability or response times during such events.
      </p>
      <br />
      <h3>13. COMPLAINTS, INCIDENT REPORTING &amp; INVESTIGATIONS</h3>
      <p>
        13.1 Reporting: Users should immediately report incidents, concerns, or
        complaints via the App or the Platforms designated email/phone. Prompt
        reporting assists in investigation and resolution.
      </p>
      <p>
        13.2 Investigation: The
        Platform will review incidents and complaints in good faith. Where an
        incident implicates Ambulance Provider negligence or regulatory
        non-compliance, the Platform may share data with appropriate authorities as
        permitted by law.
      </p>
      <br />
      <h3>14. TERMINATION &amp; SUSPENSION</h3>
      <p>
        14.1 The Platform reserves the right to suspend or terminate access to the
        App for breach of these Terms, fraudulent activity, misuse, or for any
        reason in the Platform's sole discretion.
      </p>
      <p>
        14.2 Users may terminate their account by contacting the Platform, subject
        to retention obligations and pending dispute resolution.
      </p>
      <br />
      <h3>15. MODIFICATIONS TO TERMS</h3>
      <p>
        15.1 The Platform may modify these Terms from time to time. Material changes
        will be communicated via the App, email, or other reasonable means.
        Continued use of the App after notification constitutes acceptance of the
        modified Terms.
      </p>
      <br />
      <h3>16. INTELLECTUAL PROPERTY RIGHTS</h3>
      <p>
        16.1 All intellectual property rights in and to the App, including
        trademarks, logos, content, and software, belong to the Platform or its
        licensors. Google Maps, Google Search and other google logos used in the
        application are the property of Google LLC. Users shall not copy, reproduce,
        or create derivative works except as permitted under applicable law.
      </p>
      <br />
      <h3>17. GOVERNING LAW &amp; DISPUTE RESOLUTION</h3>
      <p>
        17.1 These Terms shall be governed by and construed in accordance with the
        laws of India.
      </p>
      <p>
        17.2 Disputes shall be subject to the exclusive jurisdiction of the courts
        located in Kalyani, India.
      </p>
      <br />
      <h3>18. MISCELLANEOUS</h3>
      <p>
        18.1 Severability: If any provision is unenforceable, the remainder will
        remain in full force and effect.
      </p>
      <p>
        18.2 Assignment: The Platform may assign or transfer its rights and
        obligations without consent; Users may not assign without prior written
        consent.
      </p>
      <p>
        18.3 Entire Agreement: These Terms constitute the entire agreement between
        you and the Platform regarding use of the App.
      </p>
      <br />
      <h3>19. CONTACT INFORMATION</h3>
      <p>Matri Mission 'O' Mandir Seva Trust</p>
      <p>Address: A-9/155, Kalyani, Nadia, West Bengal, India, 741235.</p>
      <p>Email: info@mail.matrimission.org</p>
      <p>Phone: +91 70594 28773</p>
      <p>Website: <a href="https://www.matrimission.org">www.matrimission.org</a></p>
    </>
  );
}
